/*
 * @Author: llzq
 * @Date: 2021-10-05 14:15:24
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 13:47:08
 * @Description:  头部注释
 */
import React, { Component } from 'react'
import {Collapse} from 'antd'
// components
import ClazzItemView from './clazzItemView'
// model
import ChapterClazzItem from '../models/chapterClazzItem'
// style
import './style.less'
interface iProps {
    width?: number
    chapterClazzList: ChapterClazzItem[]
    progressShow?: boolean,
    currentClazz: ChapterClazzItem,
    changeCurrentClazz: (chapterClazzItem: ChapterClazzItem) => void
    activeKeys: string[],
    changeCollapse: (activeKeys: string[]) => void
}
interface iState {
}
const { Panel } = Collapse;
export default class chapterClazzView extends Component<iProps, iState> {
    state: iState = {
    }
    render() {
        let {width = 350, chapterClazzList, progressShow, 
            currentClazz, changeCurrentClazz, activeKeys} = this.props
        return (
            <div className="chapter" >
                <Collapse activeKey={activeKeys} onChange={this.props.changeCollapse}>
                    {
                        chapterClazzList.map(chapterItem => 
                                chapterItem.classType === 'CHAPTER' ? 
                                <Panel header={`${chapterItem.title}`} key={chapterItem.id}>
                                    {
                                        chapterItem.subClass && !!(chapterItem.subClass.length) && chapterItem.subClass.map(childrenItem => 
                                            (
                                                childrenItem.classType === 'SECTION'? 
                                                <div className="clazzview_section">
                                                    <div className="clazzview_section_title">
                                                        {childrenItem.title}
                                                    </div>
                                                    {
                                                        childrenItem.subClass && !!(childrenItem.subClass.length) && 
                                                        childrenItem.subClass.map(clazzItem => 
                                                            <ClazzItemView
                                                                itemClick={changeCurrentClazz}
                                                                chapterClazzItem={clazzItem} 
                                                                playing={clazzItem?.id === currentClazz?.id} progressShow={progressShow}>
                                                            </ClazzItemView>
                                                        )
                                                    }
                                                </div>:
                                                <ClazzItemView
                                                    itemClick={changeCurrentClazz}
                                                    chapterClazzItem={childrenItem} 
                                                    playing={childrenItem?.id === currentClazz?.id} progressShow={progressShow}>
                                                </ClazzItemView>)
                                        )
                                    }
                                </Panel>
                                :<ClazzItemView 
                                        itemClick={changeCurrentClazz}
                                        chapterClazzItem={chapterItem} 
                                        playing={chapterItem?.id === currentClazz?.id} progressShow={progressShow}>
                                    </ClazzItemView>
                        )
                    }
                </Collapse>
            </div>
        )
    }
}
